import { EditButton } from './EditButton/EditButton'
import './EditButton/EditButton.scss'
export default EditButton
